import FormGeneralError from 'components/formComponents/FormGeneralError';
import { PopupOrPanel } from 'components/popupsAndPanels/PopupAndPanels';
import React from 'react';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  archive: () => void;
  error: string;
};

const ArchiveInstantly: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  archive,
  error,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Archive now'}
      position="right"
      primaryBtnTxt="Archive"
      secondaryBtnTxt="Cancel"
      givenClass="DeleteManagedUser"
      primaryBtnColor="BtnRed"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={archive}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={400}
      zIndexVal={25}
    >
      <FormGeneralError message={error} />
      <p>This action will archive all subjects you are subscribe to.</p>
      <p>Are you sure you want to continue?</p>
    </PopupOrPanel>
  );
};

export default ArchiveInstantly;
